import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { Calendar, Receipt, Upload, Wallet } from 'lucide-react';
import FinancesPage from '@/features/dashboard/finances/pages/FinancesPage.tsx';
import { type ScreenTab } from '@/components/ui/TabScreen.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';
import { FinancesTab } from '@/features/dashboard/finances/routes/financesTabs.ts';

export { FinancesTab } from '@/features/dashboard/finances/routes/financesTabs.ts';

export const FINANCES_TABS: readonly ScreenTab<FinancesTab>[] = [
  {
    value: FinancesTab.PLANNED,
    label: 'Zaplanowane wpłaty',
    icon: Calendar,
    hint: 'czego oczekujemy',
  },
  {
    value: FinancesTab.EXPENSES,
    label: 'Zaplanowane wydatki',
    icon: Wallet,
    hint: 'co mamy zapłacić',
  },
  {
    value: FinancesTab.TRANSACTIONS,
    label: 'Transakcje',
    icon: Receipt,
    hint: 'historia wpłat',
  },
  {
    value: FinancesTab.IMPORTED,
    label: 'Zaimportowane',
    icon: Upload,
    hint: 'wyciągi z banku',
  },
];

const searchSchema = listSearchSchema.extend({
  // Brak zakładki to menu na wąskim ekranie — patrz `TabScreen`.
  tab: z.enum(FinancesTab).optional().catch(undefined),
});

export const financesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/finances',
  component: FinancesPage,
  validateSearch: searchSchema,
});
